import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Avatar from "./Avatar";
import VerifiedBadge from "./VerifiedBadge";
import { Flame, Heart } from "lucide-react";

export default function TrendingPlayers() {
  const [players, setPlayers] = useState(null);

  useEffect(() => {
    api.get("/trending?limit=5").then(({ data }) => setPlayers(data)).catch(() => setPlayers([]));
  }, []);

  if (players === null || players.length === 0) return null;

  return (
    <aside data-testid="trending-sidebar" className="bg-[#121212] border border-[#262626] rounded-sm">
      <div className="px-4 py-3 border-b border-[#262626] flex items-center gap-2">
        <Flame className="w-4 h-4 text-white" />
        <h3 className="font-display text-sm tracking-widest uppercase text-white">
          Trending this week
        </h3>
      </div>
      <ul className="divide-y divide-[#262626]">
        {players.map((p) => (
          <li key={p.id} data-testid={`trending-player-${p.id}`} className="p-3 flex items-center gap-3">
            <div className="font-display text-xl text-[#404040] w-6 text-center shrink-0">
              {p.rank}
            </div>
            <Link to={`/profile/${p.id}`} className="shrink-0">
              <Avatar url={p.avatar_url} name={p.name} size={36} />
            </Link>
            <div className="flex-1 min-w-0">
              <Link
                to={`/profile/${p.id}`}
                className="block text-sm text-white font-semibold truncate hover:underline"
              >
                {p.name} <VerifiedBadge role={p.role} verified={p.verified} size={12} />
              </Link>
              <div className="text-[10px] uppercase tracking-widest text-[#737373] truncate">
                {p.position || p.role}
                {p.team ? ` · ${p.team}` : ""}
              </div>
            </div>
            <div
              className="flex items-center gap-1 text-xs text-white shrink-0"
              data-testid={`trending-likes-${p.id}`}
            >
              <Heart className="w-3.5 h-3.5 fill-red-500 text-red-500" />
              {p.weekly_likes}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
}
